export default __webpack_public_path__ + "static/media/416.cc4294ad.png";